module.exports = __webpack_public_path__ + "img/AT0000002625521.958baddb.png";